import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { parseHTML, formatDate } from "../../utilities";
import { mobileMenuOffset, GridWrapper, Date } from "../../theme";
import Presentation from "../Presentation";
import ContentList from "../content/ContentList";

const Banner = styled.div`
  background: black;
  height: 672px;
  position: relative;

  @media (max-width: 767px) {
    height: calc(100vh - ${mobileMenuOffset} + 44px);
    max-height: 672px;
    min-height: calc(568px - ${mobileMenuOffset} + 44px);
  }

  :after {
    content: "";
    background: url(${(props) => props.background}) center;
    background-size: cover;
    left: 0;
    height: 100%;
    opacity: 0.65;
    position: absolute;
    top: 0;
    width: 100%;
  }

  > div {
    height: 100%;
    position: relative;
  }

  header {
    bottom: 163px;
    padding: 0 124px;
    position: absolute;
    width: 100%;
    z-index: 1;

    @media (max-width: 1599px) {
      padding: 0;
    }

    @media (max-width: 767px) {
      bottom: 50%;
      text-align: center;
      transform: translateY(50%);
    }
  }

  h1 {
    color: white;
    font-size: 4.8rem;
    font-weight: 500;
    letter-spacing: -0.12rem;
    line-height: 6rem;
    margin: 18px 0;
    text-shadow: 0px 1px 10px rgba(0, 0, 0, 0.75);

    @media (max-width: 767px) {
      font-size: 3rem;
      line-height: 3.8rem;
    }
  }
`;

const Body = styled(GridWrapper)`
  margin-top: -70px;

  @media (max-width: 767px) {
    margin-top: -30px;
  }
`;

const Description = styled(Presentation)`
  margin-bottom: 60px;
`;

function TopicPage({ topic }) {
  return (
    <article>
      <Banner background={topic.thumb_hero_url}>
        <GridWrapper>
          <header>
            <Date>{formatDate(topic.published_at)}</Date>
            <h1>{parseHTML(topic.rich_title)}</h1>
          </header>
        </GridWrapper>
      </Banner>
      <Body>
        <Description content={topic.headline} shareText={topic.title} />
        <ContentList contentList={{ content: topic.stories }} />
      </Body>
    </article>
  );
}

TopicPage.propTypes = {
  topic: PropTypes.shape({
    thumb_hero_url: PropTypes.string.isRequired,
    published_at: PropTypes.string.isRequired,
    rich_title: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    stories: PropTypes.array.isRequired,
  }).isRequired,
};

export default TopicPage;
